import { MenuListActions } from "@src/store/menulist/actionCreators";
import { AllAttributesListSectionState as AttributesListSectionState } from "./state/allAttributesListSectionState";
import { AttributeListSectionActions } from "../actions/action_creators";
import { AttributeListSectionActionTypes } from "../actions/types";

const initialState: AttributesListSectionState = {
  attributes: [],
  isLoading: false,
};

const attributesListSectionReducer = (
  state = initialState,
  action: AttributeListSectionActions
): AttributesListSectionState => {
  switch (action.type) {
    case AttributeListSectionActionTypes.START_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case AttributeListSectionActionTypes.SUCCESS:
      return {
        attributes: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default attributesListSectionReducer;
